import { finalize, take } from 'rxjs/operators';
import { InvoiceService } from './../../services/resources/invoice.service';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-service-log',
  templateUrl: './service-log.component.html',
  styleUrls: ['./service-log.component.scss']
})
export class ServiceLogComponent implements OnInit {

  isLoading: boolean = false
  data: any = {}
  page: number = 1;
  total: number = 0
  itemsPerPage: number = 7
  subscription: Subscription

  constructor(private invoiceService: InvoiceService) { }

  ngOnInit(): void {
    this.geteInvoices(1)
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  geteInvoices(page: number){    
    this.isLoading = true
    let data = {"page":page,"count":this.itemsPerPage,"sortBy":"id","direction":"desc"}
    this.subscription = this.invoiceService.post(data)
    .pipe(take(1), finalize(() => this.isLoading = false))
    .subscribe(
      res => {
        this.page = page
        this.data = res['data']   
        this.total = res['total']     
      }
    )
  }

}
